import React from "react";
import { Link } from "react-scroll";

//Assets
// import ninja from "../../Assets/ninja.svg";
import line from "../../Assets/lines.svg";
import youtube from "../../Assets/youtubelogo.svg";
import inlogo from "../../Assets/in.svg";
import insta from "../../Assets/insta.svg";
import fb from "../../Assets/fb.svg";

//Components
import HomeModel from "./HomeModel";

// Component
import AnimatedText from "./AnimatedText";

function HomeSection() {
  const landingText = {
    type: "container",
    text: "Stark",
  };

  const landingText2 = {
    type: "container",
    text: "Industries",
  };

  const landingText3 = {
    type: "container",
    text: "Focus on what matters – we spent seven years building a",
  };

  const landingText4 = {
    type: "container",
    text: "perfect 3D avatar system, The world’s most open and",
  };

  const landingText5 = {
    type: "container",
    text: "advanced real-time 3D creation tool",
  };

  return (
    <div className="homeSection">
      <div className="homeSection_info">
        <div className="homeSection_title">
          <div className="landing_content_txt3"></div>
          <AnimatedText {...landingText} delay={0} />
          <AnimatedText {...landingText2} delay={0} />
        </div>
        <div className="homeSection_description">
          <AnimatedText {...landingText3} delay={1000} />
          <AnimatedText {...landingText4} delay={1000} />
          <AnimatedText {...landingText5} delay={1000} />
        </div>
        <Link className="homeSection_btn" to="contactUsSection" smooth={true} duration={1000}>
          <div>Get in touch</div>
        </Link>
      </div>
      <div className="homeSection_model">
        {/* <img src={ninja} alt="3D Model" /> */}
        <HomeModel />
        <div className="moon"></div>
        <div className="stopdiv"></div>
      </div>

      <div className="socialinks">
        <div>
          <img src={youtube} alt="3D Model" />
        </div>
        <div>
          <img src={fb} alt="3D Model" />
        </div>
        <div>
          <img src={insta} alt="3D Model" />
        </div>
        <div>
          <img src={inlogo} alt="3D Model" />
        </div>
      </div>

      <div className="line">
        <img src={line} alt="3D Model" />
      </div>

      <div className="arrow_container">
        <div className="arrow"></div>
        <div className="arrow"></div>
        <div className="arrow"></div>
      </div>
    </div>
  );
}

export default HomeSection;
